export default {
  app: {
    name: 'NomadMate',
  },
  notFound: {
    title: 'Pagina niet gevonden',
    description: 'De pagina die u zoekt bestaat niet',
    goBack: 'Terug naar home',
  },
  common: {
    loading: 'Laden...',
    noData: 'Geen gegevens beschikbaar',
    error: 'Er is iets misgegaan, probeer opnieuw',
    retry: 'Opnieuw proberen',
    authExpired: 'Sessie verlopen, log opnieuw in',
    requestFailed: 'Verzoek mislukt',
    networkError: 'Netwerkfout, controleer uw verbinding',
    skipToContent: 'Ga naar hoofdinhoud',
  },
  nav: {
    dashboard: 'Dashboard',
    visa: 'Visum',
    cost: 'Kosten',
    timezone: 'Tijdzone',
    tax: 'Belasting',
    guide: 'Gids',
    login: 'Inloggen',
  },
  footer: {
    about: 'Over ons',
    privacy: 'Privacy',
    terms: 'Voorwaarden',
    copyright: '© 2026 NomadMate',
  },
  index: {
    hero: {
      title: 'Uw digitale nomadenleven, georganiseerd',
      subtitle: 'Al-in-one visumtracking, kostenvergelijking, tijdzonecoördinatie, belastingnaleving en stedengidsen',
      cta: 'Gratis beginnen',
      learnMore: 'Meer informatie',
    },
    features: {
      title: 'Functies',
      visa: { title: 'Visumtracker', desc: 'Volg visumtypen, geldigheid en verlengingsherinneringen' },
      cost: { title: 'Kostenvergelijk', desc: 'Vergelijk levenskosten: huisvesting, voedsel, vervoer en meer' },
      timezone: { title: 'Tijdzonebeheer', desc: 'Multi-tijdzone klokken en vergadercoördinatie over tijdzones' },
      tax: { title: 'Belastingassistent', desc: 'Grensoverschrijdende belastingregels en verblijfsdagen-waarschuwingen' },
      guide: { title: 'Stadsgids', desc: 'Gedetailleerde gidsen voor digitale nomadenbestemmingen wereldwijd' },
    },
    stats: {
      countries: 'Landen',
      cities: 'Steden',
      languages: 'Talen',
    },
  },
  login: {
    login: 'Inloggen',
    register: 'Registreren',
    subtitle: 'Log in op NomadMate en beheer uw nomadenleven',
    registerSubtitle: 'Maak een account aan en begin uw digitale nomadenavontuur',
    email: 'E-mail',
    emailPlaceholder: 'uw@email.com',
    emailInvalid: 'Voer een geldig e-mailadres in',
    username: 'Gebruikersnaam',
    usernamePlaceholder: 'Voer gebruikersnaam in',
    password: 'Wachtwoord',
    passwordPlaceholder: '••••••••',
    passwordTooShort: 'Wachtwoord moet minimaal 6 tekens bevatten',
    confirmPassword: 'Bevestig wachtwoord',
    confirmPasswordPlaceholder: 'Voer wachtwoord opnieuw in',
    passwordMismatch: 'Wachtwoorden komen niet overeen',
    loading: 'Inloggen...',
    error: 'Inloggen mislukt, probeer opnieuw',
    orContinueWith: 'Of ga verder met',
    noAccount: 'Nog geen account?',
    hasAccount: 'Al een account?',
  },
  dashboard: {
    welcome: 'Welkom terug, {name}',
    subtitle: 'Overzicht van uw nomadenleven',
    stats: {
      activeVisas: 'Actieve visa',
      daysUntilExpiry: 'Dagen tot verloop',
      citiesCompared: 'Steden vergeleken',
      timezones: 'Gevolgde tijdzones',
    },
    expiryAlerts: 'Visumverloopwaarschuwingen',
    noAlerts: 'Geen verloopwaarschuwingen',
    daysLeft: '{days} dagen resterend',
    worldClocks: 'Wereldklokken',
    quickActions: 'Snelle acties',
    actions: {
      visa: 'Visumtracker',
      cost: 'Kostenvergelijk',
      timezone: 'Tijdzones',
      tax: 'Belastingassistent',
      guide: 'Stadsgids',
    },
    recentActivity: 'Recente activiteit',
    noActivity: 'Geen recente activiteit',
  },
  visa: {
    title: 'Visumbeheer',
    subtitle: 'Volg en beheer uw visuminformatie',
    searchPlaceholder: 'Zoek op land...',
    allRegions: 'Alle regio\'s',
    regions: {
      europe: 'Europa',
      asia: 'Azië',
      americas: 'Amerika',
      oceania: 'Oceanië',
    },
    noCountries: 'Geen landen gevonden',
    requirements: 'Vereisten',
    documents: 'Vereiste documenten',
    track: 'Dit visum volgen',
    applyUrl: 'Aanvraaglink',
    myTracked: 'Mijn gevolgde visa',
  },
  cost: {
    title: 'Levenskosten',
    subtitle: 'Vergelijk levenskosten tussen verschillende steden',
    selectCities: 'Steden selecteren',
    selectHint: 'Selecteer 2-4 steden om te vergelijken',
    compare: 'Vergelijken',
    selectedCount: '{count} steden geselecteerd',
    comparison: 'Vergelijking',
    category: 'Categorie',
    nomadScore: 'Nomadenscore',
    budgetFinder: 'Budgetzoeker',
    budgetPlaceholder: 'Voer maandelijks budget in',
    findCities: 'Steden zoeken',
    aiSuggestion: 'AI-suggesties binnenkort',
  },
  timezone: {
    title: 'Tijdzonebeheer',
    subtitle: 'Beheer multi-tijdzone schema\'s en vergaderingen',
    addTimezone: 'Tijdzone toevoegen',
    noTimezones: 'Klik boven om tijdzones toe te voegen',
    meetingScheduler: 'Vergaderplanner',
    meetingHint: 'Selecteer de tijdzones van deelnemers om het beste tijdstip te vinden',
    findMeeting: 'Vergadertijd zoeken',
    finding: 'Zoeken...',
    bestTime: 'Beste tijdstip',
    workingOverlap: 'Overlap werktijden',
  },
  tax: {
    title: 'Belastingassistent',
    subtitle: 'Grensoverschrijdende belastingberekening en naleving',
    rules: 'Belastingregels',
    selectCountry: 'Land selecteren',
    thresholdDays: 'Drempel verblijfsdagen',
    days: 'dagen',
    taxRates: 'Belastingtarieven',
    reportingRequirements: 'Aangifteverplichtingen',
    importantDates: 'Belangrijke data',
    residenceTracker: 'Verblijfsdagen tracker',
    noResidenceDays: 'Geen verblijfsdagen geregistreerd',
    riskIndicator: 'Belastingrisico-indicator',
    noRiskData: 'Geen risicogegevens beschikbaar',
    countries: {
      portugal: 'Portugal',
      thailand: 'Thailand',
      spain: 'Spanje',
      germany: 'Duitsland',
      estonia: 'Estland',
      georgia: 'Georgië',
      croatia: 'Kroatië',
      mexico: 'Mexico',
      colombia: 'Colombia',
      indonesia: 'Indonesië',
      japan: 'Japan',
      southKorea: 'Zuid-Korea',
      unitedKingdom: 'Verenigd Koninkrijk',
      unitedStates: 'Verenigde Staten',
    },
  },
  guide: {
    title: 'Stadsgids',
    subtitle: 'Gidsen voor digitale nomadenbestemmingen wereldwijd',
    allContinents: 'Alle',
    noCities: 'Geen steden gevonden',
    backToList: 'Terug naar lijst',
    internetQuality: 'Internetkwaliteit',
    safetyRating: 'Veiligheidsbeoordeling',
    climate: 'Klimaat',
    communitySize: 'Gemeenschapsgrootte',
    coworkingSpaces: 'Coworkingruimtes',
    noCoworking: 'Geen coworkingruimtes beschikbaar',
    day: 'dag',
  },
  settings: {
    title: 'Instellingen',
    subtitle: 'Beheer uw account en app-voorkeuren',
    profile: 'Profiel',
    username: 'Gebruikersnaam',
    email: 'E-mail',
    saveProfile: 'Profiel opslaan',
    saving: 'Opslaan...',
    language: 'Taal',
    notifications: 'Meldingen',
    visaExpiryNotif: 'Visumverloopherinneringen',
    taxReminderNotif: 'Belastingherinneringen',
    appearance: 'Weergave',
    light: 'Licht',
    dark: 'Donker',
    baseTimezone: 'Basistijdzone',
    dangerZone: 'Gevarenzone',
    dangerDesc: 'Deze acties zijn onomkeerbaar, ga voorzichtig te werk',
    deleteAccount: 'Account verwijderen',
    confirmDelete: 'Accountverwijdering bevestigen',
    confirmDeleteDesc: 'Dit verwijdert permanent uw account en alle gegevens. Deze actie kan niet ongedaan worden gemaakt.',
    cancel: 'Annuleren',
    confirm: 'Verwijderen',
  },
  about: {
    title: 'Over ons',
    subtitle: 'NomadMate - Digitale nomaden leven-assistent',
    version: 'Versie',
    versionNumber: '1.0.0',
    description: 'NomadMate is een assistent ontworpen voor digitale nomaden, met visumbeheer, levenskostenvergelijking, tijdzonebeheer, belastingberekening en stadsgidsen om uw wereldwijde nomadenleven te vergemakkelijken.',
    openSource: 'Open source erkenningen',
    openSourceDesc: 'Dit project is gebouwd op de volgende uitstekende open source projecten',
    contact: 'Neem contact op',
    support: 'Technische ondersteuning',
    feedback: 'Feedback',
    privacyPolicy: 'Privacybeleid',
    terms: 'Servicevoorwaarden',
  },
}
